export default "__VITE_ASSET__DGf952cG__"